import React, { useRef, useEffect, useState } from 'react';
import { useSpring, animated } from 'react-spring';

const AnimatedCounter = ({ value, duration = 2000, className = '' }) => {
  const [inView, setInView] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const { number } = useSpring({
    from: { number: 0 },
    number: inView ? value : 0,
    config: { duration },
    reset: false,
  });

  return (
    <span ref={ref} className={className}>
      <animated.span>
        {number.to(n => Math.floor(n))}
      </animated.span>
    </span>
  );
};

export default AnimatedCounter; 